// extracted by mini-css-extract-plugin
export default {"background":"auth_background__wjo9+","form":"auth_form__DHHZ8","logo":"auth_logo__QldLV","midInput":"auth_midInput__6VKmc","icon":"auth_icon__3IAXP","login":"auth_login__M0LWH"};